import countries from './GetCountries';

// Normalizes user-entered phone numbers to E.164 (e.g. +639171234567).
// Keep in sync with functions/common/phoneUtils.js (server-side copy).
//
// Accepted input for calling code 63 (Philippines), all -> +639171234567:
//   9171234567, 09171234567, 639171234567, +639171234567,
//   00639171234567, +63 917 123 4567, (0917) 123-4567, +6309171234567
export const normalizePhone = (input, defaultCallingCode) => {
    if (input === null || input === undefined) {
        return '';
    }
    const text = String(input).trim();
    const ext = String(defaultCallingCode || '').replace(/[^0-9]/g, '');
    let digits = text.replace(/[^0-9]/g, '');
    if (!digits) {
        return '';
    }

    let international;
    if (text.startsWith('+')) {
        international = digits;
    } else if (digits.startsWith('00')) {
        international = digits.substring(2);
    } else if (ext && digits.startsWith(ext) && digits.length >= ext.length + 9) {
        // Country code typed without "+", e.g. 639171234567
        international = digits;
    } else {
        // A local number needs a known country code; never guess one
        digits = digits.replace(/^0+/, '');
        if (!digits || !ext) {
            return '';
        }
        international = ext + digits;
    }

    // Drop a trunk "0" typed after the country code (+63 0917...). Italy (+39) keeps it.
    if (ext && ext !== '39' && international.startsWith(ext + '0')) {
        international = ext + international.substring(ext.length).replace(/^0+/, '');
    }
    // E.164 allows at most 15 digits; anything under 8 is not a usable number
    if (international.length < 8 || international.length > 15) {
        return '';
    }
    // Philippine national numbers: mobiles (start with 9) are 10 digits, landlines 9-10
    if (international.startsWith('63')) {
        const national = international.substring(2);
        if (national.length < 9 || national.length > 10 || (national.startsWith('9') && national.length !== 10)) {
            return '';
        }
    }
    return '+' + international;
};

// Calling code ("63") from a picker label such as "(+63) Philippines" or "Philippines (+63)".
export const callingCodeFromLabel = (label) => {
    const match = /\+?\(?\+(\d{1,4})\)?/.exec(String(label || ''));
    return match ? match[1] : '';
};

// Calling code for a country name from settings.country, e.g. "Philippines" -> "63".
export const callingCodeForCountry = (countryLabel) => {
    const wanted = String(countryLabel || '').trim().toLowerCase();
    const match = wanted ? countries.find((c) => c.label.toLowerCase() === wanted) : null;
    return match ? String(match.phone) : '';
};